import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { WatchList } from '../../models/WatchList';
import { CreateWatchListDto } from '../../services/dtos/watchLists/createWatchList.dto';
import { createWatchList } from '../../services/watchLists/watchLists.service';
import { Channels } from '../../utils/channels';
import { invalidateFeedQueries } from '../../utils/invalidateFeedQueries';
import { queryKeys } from '../queryKeyFactory';
import { mapWatchlistDtoToWatchlist } from './utils/watchLists.mappers';

export default (): UseMutationResult<WatchList, void, CreateWatchListDto, void> => {
  const queryClient = useQueryClient();

  return useMutation(async (watchList: CreateWatchListDto) => {
    const createdWatchlist = await createWatchList(watchList);
    const transformedCreatedWatchlist = mapWatchlistDtoToWatchlist(createdWatchlist);

    const watchlistsCache = queryClient.getQueriesData<WatchList[]>(queryKeys.fetchWatchlists.all);
    if (watchlistsCache.length) {
      const updatedWatchlists = [...watchlistsCache[0][1]];
      updatedWatchlists.push(transformedCreatedWatchlist);
      queryClient.setQueryData(queryKeys.fetchWatchlists.all, updatedWatchlists);
    } else {
      queryClient.setQueryData(queryKeys.fetchWatchlists.all, [transformedCreatedWatchlist]);
    }

    invalidateFeedQueries(queryClient);
    Channels.watchlistsChannel.postMessage(createdWatchlist.id);

    return transformedCreatedWatchlist;
  });
};
